export const carsData = {
  "maruti-suzuki": {
    brandName: "Maruti Suzuki",
    models: [
      {
        id: 1,
        model: "Baleno",
        variants: [
          {
            id: "baleno-1",
            name: "2018 Maruti Baleno Zeta 1.2 AT",
            variant: "Zeta 1.2 AT",
            price: "₹5.62 Lakh",
            year: "2018",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "36K km",
            location: "Bangalore",
            image: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=500",
            condition: "High quality, less driven",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-2",
            name: "2024 Maruti Baleno Zeta AGS",
            variant: "Zeta AGS",
            price: "₹7.48 Lakh",
            year: "2024",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "19.5K km",
            location: "Bangalore",
            image: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=500",
            condition: "Latest cars, 3 year warranty",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-3",
            name: "2018 Maruti Baleno Delta 1.2",
            variant: "Delta 1.2",
            price: "₹4.19 Lakh",
            year: "2018",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "50.5K km",
            location: "Mumbai",
            image: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=500",
            condition: "Highly affordable",
            assured: false,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-4",
            name: "2020 Maruti Baleno Alpha 1.2",
            variant: "Alpha 1.2",
            price: "₹5.99 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "42K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-5",
            name: "2021 Maruti Baleno Zeta",
            variant: "Zeta",
            price: "₹6.25 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "28K km",
            location: "Delhi",
            image: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=500",
            condition: "Excellent condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-6",
            name: "2022 Maruti Baleno Alpha AT",
            variant: "Alpha AT",
            price: "₹7.15 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "22K km",
            location: "Chennai",
            image: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=500",
            condition: "Premium condition",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-7",
            name: "2020 Maruti Baleno Delta",
            variant: "Delta",
            price: "₹5.45 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "35K km",
            location: "Lucknow",
            image: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-8",
            name: "2019 Maruti Baleno Zeta",
            variant: "Zeta",
            price: "₹5.85 Lakh",
            year: "2019",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "38K km",
            location: "Delhi NCR",
            image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-9",
            name: "2021 Maruti Baleno Alpha",
            variant: "Alpha",
            price: "₹6.75 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "25K km",
            location: "Hyderabad",
            image: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=500",
            condition: "Excellent condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-10",
            name: "2020 Maruti Baleno Zeta AGS",
            variant: "Zeta AGS",
            price: "₹6.35 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "32K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-11",
            name: "2022 Maruti Baleno Zeta",
            variant: "Zeta",
            price: "₹7.25 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "18K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=500",
            condition: "Like new",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-12",
            name: "2019 Maruti Baleno Delta",
            variant: "Delta",
            price: "₹5.55 Lakh",
            year: "2019",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "40K km",
            location: "Ahmedabad",
            image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-13",
            name: "2021 Maruti Baleno Alpha AT",
            variant: "Alpha AT",
            price: "₹6.95 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "26K km",
            location: "Kolkata",
            image: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=500",
            condition: "Premium condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "baleno-14",
            name: "2020 Maruti Baleno Zeta",
            variant: "Zeta",
            price: "₹6.15 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "34K km",
            location: "Jaipur",
            image: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          }
        ]
      },
      {
        id: 2,
        model: "Swift",
        variants: [
          {
            id: "swift-1",
            name: "2019 Maruti Swift VXI",
            variant: "VXI",
            price: "₹5.25 Lakh",
            year: "2019",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "38K km",
            location: "Delhi",
            image: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=500",
            condition: "Excellent condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-2",
            name: "2023 Maruti Swift ZXI+ AMT",
            variant: "ZXI+ AMT",
            price: "₹7.89 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "AMT",
            kmDriven: "15K km",
            location: "Chennai",
            image: "https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=500",
            condition: "Like new",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-3",
            name: "2020 Maruti Swift VXI",
            variant: "VXI",
            price: "₹5.65 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "32K km",
            location: "Bangalore",
            image: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-4",
            name: "2021 Maruti Swift ZXI",
            variant: "ZXI",
            price: "₹6.45 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "28K km",
            location: "Mumbai",
            image: "https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=500",
            condition: "Excellent condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-5",
            name: "2022 Maruti Swift ZXI+ AMT",
            variant: "ZXI+ AMT",
            price: "₹7.25 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "AMT",
            kmDriven: "20K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=500",
            condition: "Premium condition",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-6",
            name: "2019 Maruti Swift VXI AMT",
            variant: "VXI AMT",
            price: "₹5.85 Lakh",
            year: "2019",
            fuel: "Petrol",
            transmission: "AMT",
            kmDriven: "35K km",
            location: "Lucknow",
            image: "https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-7",
            name: "2020 Maruti Swift ZXI",
            variant: "ZXI",
            price: "₹6.15 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "30K km",
            location: "Delhi NCR",
            image: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-8",
            name: "2021 Maruti Swift ZXI+ AMT",
            variant: "ZXI+ AMT",
            price: "₹6.95 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "AMT",
            kmDriven: "24K km",
            location: "Hyderabad",
            image: "https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=500",
            condition: "Excellent condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-9",
            name: "2020 Maruti Swift VXI",
            variant: "VXI",
            price: "₹5.95 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "31K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-10",
            name: "2022 Maruti Swift ZXI",
            variant: "ZXI",
            price: "₹7.15 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "19K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=500",
            condition: "Like new",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-11",
            name: "2019 Maruti Swift VXI",
            variant: "VXI",
            price: "₹5.45 Lakh",
            year: "2019",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "37K km",
            location: "Ahmedabad",
            image: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-12",
            name: "2021 Maruti Swift ZXI+ AMT",
            variant: "ZXI+ AMT",
            price: "₹6.85 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "AMT",
            kmDriven: "25K km",
            location: "Kolkata",
            image: "https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=500",
            condition: "Premium condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "swift-13",
            name: "2020 Maruti Swift ZXI",
            variant: "ZXI",
            price: "₹6.05 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "33K km",
            location: "Jaipur",
            image: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          }
        ]
      },
      {
        id: 3,
        model: "Dzire",
        variants: [
          {
            id: "dzire-1",
            name: "2020 Maruti Dzire VXI",
            variant: "VXI",
            price: "₹6.45 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "32K km",
            location: "Hyderabad",
            image: "https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Sedan"
          },
          {
            id: "dzire-2",
            name: "2022 Maruti Dzire ZXI+ AMT",
            variant: "ZXI+ AMT",
            price: "₹8.25 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "AMT",
            kmDriven: "22K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1623093178765-a8c5e050c0e0?w=500",
            condition: "Premium condition",
            assured: true,
            assuredPlus: true,
            bodyType: "Sedan"
          }
        ]
      },
      {
        id: 4,
        model: "Ciaz",
        variants: [
          {
            id: "ciaz-1",
            name: "2019 Maruti Ciaz Delta",
            variant: "Delta",
            price: "₹7.15 Lakh",
            year: "2019",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "45K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "Sedan"
          }
        ]
      },
      {
        id: 5,
        model: "Wagon R",
        variants: [
          {
            id: "wagonr-1",
            name: "2021 Maruti Wagon R VXI",
            variant: "VXI",
            price: "₹5.50 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "28K km",
            location: "Ahmedabad",
            image: "https://images.unsplash.com/photo-1581540222194-0def2dda95b8?w=500",
            condition: "Excellent",
            assured: true,
            bodyType: "Hatchback"
          }
        ]
      },
      {
        id: 6,
        model: "Celerio",
        variants: [
          {
            id: "celerio-1",
            name: "2020 Maruti Celerio VXI",
            variant: "VXI",
            price: "₹4.75 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "35K km",
            location: "Kolkata",
            image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          }
        ]
      },
      {
        id: 7,
        model: "Brezza",
        variants: [
          {
            id: "brezza-1",
            name: "2022 Maruti Brezza VXI",
            variant: "VXI",
            price: "₹9.85 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "25K km",
            location: "Jaipur",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "SUV in great condition",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          }
        ]
      },
      {
        id: 8,
        model: "Ertiga",
        variants: [
          {
            id: "ertiga-1",
            name: "2021 Maruti Ertiga VXI",
            variant: "VXI",
            price: "₹8.95 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "30K km",
            location: "Delhi NCR",
            image: "https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=500",
            condition: "7-seater MPV",
            assured: true,
            bodyType: "MPV"
          }
        ]
      },
      {
        id: 9,
        model: "Alto",
        variants: [
          {
            id: "alto-1",
            name: "2019 Maruti Alto 800 LXI",
            variant: "LXI",
            price: "₹2.85 Lakh",
            year: "2019",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "42K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=500",
            condition: "Budget friendly",
            assured: false,
            bodyType: "Hatchback"
          }
        ]
      },
      {
        id: 10,
        model: "S-Presso",
        variants: [
          {
            id: "spresso-1",
            name: "2020 Maruti S-Presso VXI",
            variant: "VXI",
            price: "₹4.25 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "28K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=500",
            condition: "Compact SUV",
            assured: true,
            bodyType: "Hatchback"
          }
        ]
      },
      {
        id: 11,
        model: "XL6",
        variants: [
          {
            id: "xl6-1",
            name: "2022 Maruti XL6 Alpha",
            variant: "Alpha",
            price: "₹12.50 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "18K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=500",
            condition: "Premium MPV",
            assured: true,
            assuredPlus: true,
            bodyType: "MPV"
          }
        ]
      },
      {
        id: 12,
        model: "Eeco",
        variants: [
          {
            id: "eeco-1",
            name: "2020 Maruti Eeco 5 STR",
            variant: "5 STR",
            price: "₹3.45 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "55K km",
            location: "Delhi",
            image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=500",
            condition: "Commercial vehicle",
            assured: false,
            bodyType: "Van"
          }
        ]
      },
      {
        id: 13,
        model: "Ignis",
        variants: [
          {
            id: "ignis-1",
            name: "2021 Maruti Ignis Zeta",
            variant: "Zeta",
            price: "₹5.75 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "AMT",
            kmDriven: "24K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=500",
            condition: "Stylish hatchback",
            assured: true,
            bodyType: "Hatchback"
          }
        ]
      },
      {
        id: 14,
        model: "Fronx",
        variants: [
          {
            id: "fronx-1",
            name: "2023 Maruti Fronx Delta",
            variant: "Delta",
            price: "₹8.95 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "12K km",
            location: "Ghaziabad",
            image: "https://images.unsplash.com/photo-1619767886558-efdc259cde1a?w=500",
            condition: "Latest compact SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          }
        ]
      },
      {
        id: 15,
        model: "Grand Vitara",
        variants: [
          {
            id: "vitara-1",
            name: "2023 Maruti Grand Vitara Zeta",
            variant: "Zeta",
            price: "₹13.50 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "8K km",
            location: "South Delhi",
            image: "https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=500",
            condition: "Premium SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          }
        ]
      },
      {
        id: 16,
        model: "Jimny",
        variants: [
          {
            id: "jimny-1",
            name: "2024 Maruti Jimny Zeta",
            variant: "Zeta",
            price: "₹11.95 Lakh",
            year: "2024",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "5K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Off-road SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          }
        ]
      }
    ]
  },
  "tata-motors": {
    brandName: "Tata Motors",
    models: [
      {
        id: 17,
        model: "Nexon",
        variants: [
          // Bangalore
          {
            id: "nexon-bangalore-1",
            name: "2021 Tata Nexon XZ Plus",
            variant: "XZ Plus",
            price: "₹9.85 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "30K km",
            location: "Bangalore",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Excellent SUV",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-bangalore-2",
            name: "2022 Tata Nexon XZA Plus",
            variant: "XZA Plus",
            price: "₹11.25 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "22K km",
            location: "Bangalore",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Mumbai
          {
            id: "nexon-mumbai-1",
            name: "2020 Tata Nexon XZ",
            variant: "XZ",
            price: "₹8.95 Lakh",
            year: "2020",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "35K km",
            location: "Mumbai",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-mumbai-2",
            name: "2023 Tata Nexon XZ Plus Turbo",
            variant: "XZ Plus Turbo",
            price: "₹12.45 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "18K km",
            location: "Mumbai",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Latest model",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Delhi
          {
            id: "nexon-delhi-1",
            name: "2021 Tata Nexon XM",
            variant: "XM",
            price: "₹8.25 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "32K km",
            location: "Delhi",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-delhi-2",
            name: "2022 Tata Nexon XZA Plus Dark",
            variant: "XZA Plus Dark",
            price: "₹11.95 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "20K km",
            location: "Delhi",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium edition",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Noida
          {
            id: "nexon-noida-1",
            name: "2020 Tata Nexon XZ Plus",
            variant: "XZ Plus",
            price: "₹9.15 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "38K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-noida-2",
            name: "2023 Tata Nexon XZ Plus S",
            variant: "XZ Plus S",
            price: "₹12.75 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "15K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Latest SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Chennai
          {
            id: "nexon-chennai-1",
            name: "2021 Tata Nexon XZ",
            variant: "XZ",
            price: "₹9.45 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "28K km",
            location: "Chennai",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Excellent condition",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-chennai-2",
            name: "2022 Tata Nexon XZA Plus",
            variant: "XZA Plus",
            price: "₹11.65 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "21K km",
            location: "Chennai",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Lucknow
          {
            id: "nexon-lucknow-1",
            name: "2020 Tata Nexon XM",
            variant: "XM",
            price: "₹8.55 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "40K km",
            location: "Lucknow",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-lucknow-2",
            name: "2022 Tata Nexon XZ Plus",
            variant: "XZ Plus",
            price: "₹10.85 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "24K km",
            location: "Lucknow",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          // Delhi NCR
          {
            id: "nexon-delhincr-1",
            name: "2021 Tata Nexon XZ Plus",
            variant: "XZ Plus",
            price: "₹9.95 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "30K km",
            location: "Delhi NCR",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Excellent SUV",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-delhincr-2",
            name: "2023 Tata Nexon XZA Plus Dark",
            variant: "XZA Plus Dark",
            price: "₹12.95 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "12K km",
            location: "Delhi NCR",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Latest premium SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Hyderabad
          {
            id: "nexon-hyderabad-1",
            name: "2021 Tata Nexon XZ Plus",
            variant: "XZ Plus",
            price: "₹9.85 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "30K km",
            location: "Hyderabad",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Excellent SUV",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-hyderabad-2",
            name: "2022 Tata Nexon XZ Plus Turbo",
            variant: "XZ Plus Turbo",
            price: "₹11.45 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "23K km",
            location: "Hyderabad",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium condition",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Pune
          {
            id: "nexon-pune-1",
            name: "2020 Tata Nexon XZ",
            variant: "XZ",
            price: "₹8.75 Lakh",
            year: "2020",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "36K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-pune-2",
            name: "2023 Tata Nexon XZA Plus",
            variant: "XZA Plus",
            price: "₹12.25 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "16K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Latest model",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Gurgaon
          {
            id: "nexon-gurgaon-1",
            name: "2021 Tata Nexon XZ Plus Dark",
            variant: "XZ Plus Dark",
            price: "₹10.25 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "27K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Dark edition",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-gurgaon-2",
            name: "2022 Tata Nexon XZA Plus",
            variant: "XZA Plus",
            price: "₹11.85 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "19K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Ahmedabad
          {
            id: "nexon-ahmedabad-1",
            name: "2020 Tata Nexon XM",
            variant: "XM",
            price: "₹8.35 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "42K km",
            location: "Ahmedabad",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-ahmedabad-2",
            name: "2022 Tata Nexon XZ Plus",
            variant: "XZ Plus",
            price: "₹10.95 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "25K km",
            location: "Ahmedabad",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Excellent condition",
            assured: true,
            bodyType: "SUV"
          },
          // Kolkata
          {
            id: "nexon-kolkata-1",
            name: "2021 Tata Nexon XZ",
            variant: "XZ",
            price: "₹9.25 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "31K km",
            location: "Kolkata",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-kolkata-2",
            name: "2023 Tata Nexon XZA Plus",
            variant: "XZA Plus",
            price: "₹12.15 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "14K km",
            location: "Kolkata",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Latest premium SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Jaipur
          {
            id: "nexon-jaipur-1",
            name: "2020 Tata Nexon XZ",
            variant: "XZ",
            price: "₹8.85 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "37K km",
            location: "Jaipur",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "nexon-jaipur-2",
            name: "2022 Tata Nexon XZ Plus Dark",
            variant: "XZ Plus Dark",
            price: "₹11.35 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "22K km",
            location: "Jaipur",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium dark edition",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          }
        ]
      },
      {
        id: 18,
        model: "Altroz",
        variants: [
          // Bangalore
          {
            id: "altroz-bangalore-1",
            name: "2020 Tata Altroz XZ",
            variant: "XZ",
            price: "₹6.90 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "25K km",
            location: "Bangalore",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Premium hatchback",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-bangalore-2",
            name: "2022 Tata Altroz XZ Plus Dark",
            variant: "XZ Plus Dark",
            price: "₹8.45 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "18K km",
            location: "Bangalore",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Latest dark edition",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          // Mumbai
          {
            id: "altroz-mumbai-1",
            name: "2021 Tata Altroz XM",
            variant: "XM",
            price: "₹6.25 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "28K km",
            location: "Mumbai",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-mumbai-2",
            name: "2023 Tata Altroz XZ Plus",
            variant: "XZ Plus",
            price: "₹8.95 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "12K km",
            location: "Mumbai",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Latest model",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          // Delhi
          {
            id: "altroz-delhi-1",
            name: "2020 Tata Altroz XE",
            variant: "XE",
            price: "₹5.85 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "32K km",
            location: "Delhi",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-delhi-2",
            name: "2022 Tata Altroz XZ Plus Dark",
            variant: "XZ Plus Dark",
            price: "₹8.65 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "19K km",
            location: "Delhi",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Premium dark edition",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          // Noida
          {
            id: "altroz-noida-1",
            name: "2021 Tata Altroz XZ",
            variant: "XZ",
            price: "₹7.15 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "26K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Excellent condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-noida-2",
            name: "2023 Tata Altroz XZ Plus Turbo",
            variant: "XZ Plus Turbo",
            price: "₹9.25 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "10K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Latest turbo edition",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          // Chennai
          {
            id: "altroz-chennai-1",
            name: "2020 Tata Altroz XM",
            variant: "XM",
            price: "₹6.45 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "30K km",
            location: "Chennai",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-chennai-2",
            name: "2022 Tata Altroz XZ Plus",
            variant: "XZ Plus",
            price: "₹8.35 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "20K km",
            location: "Chennai",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Premium hatchback",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          // Lucknow
          {
            id: "altroz-lucknow-1",
            name: "2021 Tata Altroz XE",
            variant: "XE",
            price: "₹6.05 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "34K km",
            location: "Lucknow",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-lucknow-2",
            name: "2022 Tata Altroz XZ",
            variant: "XZ",
            price: "₹7.85 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "21K km",
            location: "Lucknow",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Excellent condition",
            assured: true,
            bodyType: "Hatchback"
          },
          // Delhi NCR
          {
            id: "altroz-delhincr-1",
            name: "2021 Tata Altroz XZ",
            variant: "XZ",
            price: "₹7.25 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "27K km",
            location: "Delhi NCR",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Premium hatchback",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-delhincr-2",
            name: "2023 Tata Altroz XZ Plus Dark",
            variant: "XZ Plus Dark",
            price: "₹9.15 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "11K km",
            location: "Delhi NCR",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Latest dark edition",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          // Hyderabad
          {
            id: "altroz-hyderabad-1",
            name: "2020 Tata Altroz XZ",
            variant: "XZ",
            price: "₹6.90 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "25K km",
            location: "Hyderabad",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Premium hatchback",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-hyderabad-2",
            name: "2022 Tata Altroz XZ Plus Turbo",
            variant: "XZ Plus Turbo",
            price: "₹8.75 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "17K km",
            location: "Hyderabad",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Turbo edition",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          // Pune
          {
            id: "altroz-pune-1",
            name: "2021 Tata Altroz XM",
            variant: "XM",
            price: "₹6.55 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "29K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-pune-2",
            name: "2023 Tata Altroz XZ Plus",
            variant: "XZ Plus",
            price: "₹8.85 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "13K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Latest model",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          // Gurgaon
          {
            id: "altroz-gurgaon-1",
            name: "2020 Tata Altroz XZ",
            variant: "XZ",
            price: "₹7.05 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "31K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-gurgaon-2",
            name: "2022 Tata Altroz XZ Plus Dark",
            variant: "XZ Plus Dark",
            price: "₹8.55 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "19K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Premium dark edition",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          // Ahmedabad
          {
            id: "altroz-ahmedabad-1",
            name: "2021 Tata Altroz XE",
            variant: "XE",
            price: "₹6.15 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "33K km",
            location: "Ahmedabad",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-ahmedabad-2",
            name: "2022 Tata Altroz XZ Plus",
            variant: "XZ Plus",
            price: "₹8.25 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "20K km",
            location: "Ahmedabad",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Premium hatchback",
            assured: true,
            bodyType: "Hatchback"
          },
          // Kolkata
          {
            id: "altroz-kolkata-1",
            name: "2020 Tata Altroz XM",
            variant: "XM",
            price: "₹6.35 Lakh",
            year: "2020",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "35K km",
            location: "Kolkata",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-kolkata-2",
            name: "2023 Tata Altroz XZ Plus Turbo",
            variant: "XZ Plus Turbo",
            price: "₹9.05 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "14K km",
            location: "Kolkata",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Latest turbo edition",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          },
          // Jaipur
          {
            id: "altroz-jaipur-1",
            name: "2021 Tata Altroz XZ",
            variant: "XZ",
            price:"₹7.05 Lakh",
            year: "2021",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "28K km",
            location: "Jaipur",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "Hatchback"
          },
          {
            id: "altroz-jaipur-2",
            name: "2022 Tata Altroz XZ Plus Dark",
            variant: "XZ Plus Dark",
            price: "₹8.45 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "18K km",
            location: "Jaipur",
            image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=500",
            condition: "Premium dark edition",
            assured: true,
            assuredPlus: true,
            bodyType: "Hatchback"
          }
        ]
      }
    ]
  },
  "mahindra": {
    brandName: "Mahindra & Mahindra",
    models: [
      {
        id: 19,
        model: "Thar",
        variants: [
          // Bangalore
          {
            id: "thar-bangalore-1",
            name: "2021 Mahindra Thar LX Hard Top",
            variant: "LX Hard Top",
            price: "₹13.50 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "25K km",
            location: "Bangalore",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Off-road beast",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-bangalore-2",
            name: "2022 Mahindra Thar LX AT Diesel",
            variant: "LX AT Diesel",
            price: "₹15.25 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "18K km",
            location: "Bangalore",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Premium automatic",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Mumbai
          {
            id: "thar-mumbai-1",
            name: "2021 Mahindra Thar AX Soft Top",
            variant: "AX Soft Top",
            price: "₹12.85 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "28K km",
            location: "Mumbai",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Adventure ready",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-mumbai-2",
            name: "2023 Mahindra Thar LX Petrol AT",
            variant: "LX Petrol AT",
            price: "₹16.45 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "12K km",
            location: "Mumbai",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Latest model",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Delhi
          {
            id: "thar-delhi-1",
            name: "2021 Mahindra Thar LX Diesel",
            variant: "LX Diesel",
            price: "₹13.75 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "26K km",
            location: "Delhi",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Excellent condition",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-delhi-2",
            name: "2022 Mahindra Thar LX Hard Top AT",
            variant: "LX Hard Top AT",
            price: "₹15.95 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "19K km",
            location: "Delhi",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Premium edition",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Noida
          {
            id: "thar-noida-1",
            name: "2021 Mahindra Thar AX Diesel",
            variant: "AX Diesel",
            price: "₹12.95 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "30K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-noida-2",
            name: "2023 Mahindra Thar LX Diesel AT",
            variant: "LX Diesel AT",
            price: "₹16.75 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "10K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Latest automatic",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Chennai
          {
            id: "thar-chennai-1",
            name: "2021 Mahindra Thar LX Hard Top",
            variant: "LX Hard Top",
            price: "₹13.45 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "27K km",
            location: "Chennai",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Off-road ready",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-chennai-2",
            name: "2022 Mahindra Thar LX Petrol AT",
            variant: "LX Petrol AT",
            price: "₹15.85 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "20K km",
            location: "Chennai",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Premium petrol AT",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Lucknow
          {
            id: "thar-lucknow-1",
            name: "2021 Mahindra Thar AX Soft Top",
            variant: "AX Soft Top",
            price: "₹12.65 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "32K km",
            location: "Lucknow",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-lucknow-2",
            name: "2022 Mahindra Thar LX Diesel",
            variant: "LX Diesel",
            price: "₹14.55 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "22K km",
            location: "Lucknow",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Excellent SUV",
            assured: true,
            bodyType: "SUV"
          },
          // Delhi NCR
          {
            id: "thar-delhincr-1",
            name: "2021 Mahindra Thar LX Diesel",
            variant: "LX Diesel",
            price: "₹13.85 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "25K km",
            location: "Delhi NCR",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Off-road beast",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-delhincr-2",
            name: "2023 Mahindra Thar LX Hard Top AT",
            variant: "LX Hard Top AT",
            price: "₹17.25 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "8K km",
            location: "Delhi NCR",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Latest premium AT",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Hyderabad
          {
            id: "thar-hyderabad-1",
            name: "2021 Mahindra Thar LX Hard Top",
            variant: "LX Hard Top",
            price: "₹13.50 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "29K km",
            location: "Hyderabad",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Adventure ready",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-hyderabad-2",
            name: "2022 Mahindra Thar LX Diesel AT",
            variant: "LX Diesel AT",
            price: "₹15.65 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "21K km",
            location: "Hyderabad",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Premium automatic",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Pune
          {
            id: "thar-pune-1",
            name: "2021 Mahindra Thar AX Diesel",
            variant: "AX Diesel",
            price: "₹12.75 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "31K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-pune-2",
            name: "2023 Mahindra Thar LX Petrol AT",
            variant: "LX Petrol AT",
            price: "₹16.35 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "11K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Latest petrol AT",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Gurgaon
          {
            id: "thar-gurgaon-1",
            name: "2021 Mahindra Thar LX Hard Top",
            variant: "LX Hard Top",
            price: "₹13.95 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "24K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Excellent condition",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-gurgaon-2",
            name: "2022 Mahindra Thar LX Diesel AT",
            variant: "LX Diesel AT",
            price: "₹15.75 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "17K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Premium automatic",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Ahmedabad
          {
            id: "thar-ahmedabad-1",
            name: "2021 Mahindra Thar AX Soft Top",
            variant: "AX Soft Top",
            price: "₹12.55 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "33K km",
            location: "Ahmedabad",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-ahmedabad-2",
            name: "2022 Mahindra Thar LX Diesel",
            variant: "LX Diesel",
            price: "₹14.45 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "23K km",
            location: "Ahmedabad",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Excellent SUV",
            assured: true,
            bodyType: "SUV"
          },
          // Kolkata
          {
            id: "thar-kolkata-1",
            name: "2021 Mahindra Thar LX Diesel",
            variant: "LX Diesel",
            price: "₹13.65 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "28K km",
            location: "Kolkata",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Adventure ready",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-kolkata-2",
            name: "2023 Mahindra Thar LX Diesel AT",
            variant: "LX Diesel AT",
            price: "₹16.55 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "9K km",
            location: "Kolkata",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Latest automatic",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Jaipur
          {
            id: "thar-jaipur-1",
            name: "2021 Mahindra Thar AX Diesel",
            variant: "AX Diesel",
            price: "₹12.85 Lakh",
            year: "2021",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "30K km",
            location: "Jaipur",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "thar-jaipur-2",
            name: "2022 Mahindra Thar LX Hard Top",
            variant: "LX Hard Top",
            price: "₹14.95 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "20K km",
            location: "Jaipur",
            image: "https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=500",
            condition: "Premium hard top",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          }
        ]
      },
      {
        id: 20,
        model: "XUV700",
        variants: [
          // Bangalore
          {
            id: "xuv700-bangalore-1",
            name: "2022 Mahindra XUV700 AX7",
            variant: "AX7",
            price: "₹18.50 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "20K km",
            location: "Bangalore",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-bangalore-2",
            name: "2023 Mahindra XUV700 AX7 AT",
            variant: "AX7 AT",
            price: "₹21.25 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "12K km",
            location: "Bangalore",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Latest automatic",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Mumbai
          {
            id: "xuv700-mumbai-1",
            name: "2022 Mahindra XUV700 AX5",
            variant: "AX5",
            price: "₹17.25 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "22K km",
            location: "Mumbai",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-mumbai-2",
            name: "2023 Mahindra XUV700 AX7 L AT",
            variant: "AX7 L AT",
            price: "₹22.95 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "10K km",
            location: "Mumbai",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Top variant",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Delhi
          {
            id: "xuv700-delhi-1",
            name: "2022 Mahindra XUV700 AX7",
            variant: "AX7",
            price: "₹18.75 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "19K km",
            location: "Delhi",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-delhi-2",
            name: "2023 Mahindra XUV700 AX7 Petrol AT",
            variant: "AX7 Petrol AT",
            price: "₹20.45 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "14K km",
            location: "Delhi",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Latest petrol AT",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Noida
          {
            id: "xuv700-noida-1",
            name: "2022 Mahindra XUV700 AX5",
            variant: "AX5",
            price: "₹17.45 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "24K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-noida-2",
            name: "2023 Mahindra XUV700 AX7 AT",
            variant: "AX7 AT",
            price: "₹21.75 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "11K km",
            location: "Noida",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium automatic",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Chennai
          {
            id: "xuv700-chennai-1",
            name: "2022 Mahindra XUV700 AX7",
            variant: "AX7",
            price: "₹18.35 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "21K km",
            location: "Chennai",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium SUV",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-chennai-2",
            name: "2023 Mahindra XUV700 AX7 L Diesel AT",
            variant: "AX7 L Diesel AT",
            price: "₹23.25 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "9K km",
            location: "Chennai",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Top variant AT",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Lucknow
          {
            id: "xuv700-lucknow-1",
            name: "2022 Mahindra XUV700 AX5",
            variant: "AX5",
            price: "₹17.15 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "25K km",
            location: "Lucknow",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Good condition",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-lucknow-2",
            name: "2023 Mahindra XUV700 AX7",
            variant: "AX7",
            price: "₹19.85 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "15K km",
            location: "Lucknow",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Delhi NCR
          {
            id: "xuv700-delhincr-1",
            name: "2022 Mahindra XUV700 AX7",
            variant: "AX7",
            price: "₹18.95 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "18K km",
            location: "Delhi NCR",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Excellent SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-delhincr-2",
            name: "2023 Mahindra XUV700 AX7 L AT",
            variant: "AX7 L AT",
            price: "₹23.45 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "8K km",
            location: "Delhi NCR",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Top variant automatic",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Hyderabad
          {
            id: "xuv700-hyderabad-1",
            name: "2022 Mahindra XUV700 AX7",
            variant: "AX7",
            price: "₹18.50 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "20K km",
            location: "Hyderabad",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium SUV",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-hyderabad-2",
            name: "2023 Mahindra XUV700 AX7 AT",
            variant: "AX7 AT",
            price: "₹21.55 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "13K km",
            location: "Hyderabad",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Latest automatic",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Pune
          {
            id: "xuv700-pune-1",
            name: "2022 Mahindra XUV700 AX5",
            variant: "AX5",
            price: "₹17.35 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "23K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-pune-2",
            name: "2023 Mahindra XUV700 AX7 L AT",
            variant: "AX7 L AT",
            price: "₹22.85 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "10K km",
            location: "Pune",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Top variant",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Gurgaon
          {
            id: "xuv700-gurgaon-1",
            name: "2022 Mahindra XUV700 AX7",
            variant: "AX7",
            price: "₹19.25 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "17K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-gurgaon-2",
            name: "2023 Mahindra XUV700 AX7 Petrol AT",
            variant: "AX7 Petrol AT",
            price: "₹20.95 Lakh",
            year: "2023",
            fuel: "Petrol",
            transmission: "Automatic",
            kmDriven: "13K km",
            location: "Gurgaon",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Latest petrol AT",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Ahmedabad
          {
            id: "xuv700-ahmedabad-1",
            name: "2022 Mahindra XUV700 AX5",
            variant: "AX5",
            price: "₹17.05 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "26K km",
            location: "Ahmedabad",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-ahmedabad-2",
            name: "2023 Mahindra XUV700 AX7 AT",
            variant: "AX7 AT",
            price: "₹21.15 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "14K km",
            location: "Ahmedabad",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium automatic",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Kolkata
          {
            id: "xuv700-kolkata-1",
            name: "2022 Mahindra XUV700 AX7",
            variant: "AX7",
            price: "₹18.65 Lakh",
            year: "2022",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "19K km",
            location: "Kolkata",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium SUV",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-kolkata-2",
            name: "2023 Mahindra XUV700 AX7 L AT",
            variant: "AX7 L AT",
            price: "₹23.05 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Automatic",
            kmDriven: "9K km",
            location: "Kolkata",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Top variant automatic",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          },
          // Jaipur
          {
            id: "xuv700-jaipur-1",
            name: "2022 Mahindra XUV700 AX5",
            variant: "AX5",
            price: "₹17.25 Lakh",
            year: "2022",
            fuel: "Petrol",
            transmission: "Manual",
            kmDriven: "22K km",
            location: "Jaipur",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Well maintained",
            assured: true,
            bodyType: "SUV"
          },
          {
            id: "xuv700-jaipur-2",
            name: "2023 Mahindra XUV700 AX7 Diesel",
            variant: "AX7 Diesel",
            price: "₹19.95 Lakh",
            year: "2023",
            fuel: "Diesel",
            transmission: "Manual",
            kmDriven: "16K km",
            location: "Jaipur",
            image: "https://images.unsplash.com/photo-1617654112368-307921291f42?w=500",
            condition: "Premium SUV",
            assured: true,
            assuredPlus: true,
            bodyType: "SUV"
          }
        ]
      }
    ]
  }
};